import React from "react";

export const ProcesoPorFuncionario = () => {
  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
          >
            <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
              {" "}
              VER PROCESO DE CALIFICACIÓN{" "}
            </h1>
            <span className="h-20px border-gray-300 border-start mx-4" />
            <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li className="breadcrumb-item text-muted">
                <a href="#" className="text-muted text-hover-primary">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
              <li className="breadcrumb-item text-dark">
                {" "}
                 INFORMACIÓN DEL/LA FUNCIONARIO/A
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
        </div>
      </div>
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bolder text-dark">
                       INFORMACIÓN DEL FUNCIONARIO{" "}
                    </span>
                  </h3>
                  <div className="card-toolbar">
                    <a
                      href="#"
                      className="btn btn-sm btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#m-"
                    >
                       ver historialde participación
                    </a>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-4 col-sm-12">
                      <input
                        type="text"
                        className="form-control mb-5"
                        placeholder="Proceso de calificación Anual 2022"
                        disabled="true"
                      />
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <select
                        className="form-select mb-5"
                        aria-label=""
                        disabled="true"
                      >
                        <option>año 2022</option>
                        <option value={2022}>2022</option>
                        <option value={2021}>2021</option>
                      </select>
                    </div>
                    <div className="col-lg-4 col-sm-12"></div>
                    <div className="col-lg-4 col-sm-12">
                      <input
                        type="text"
                        className="form-control mb-5"
                        placeholder="Ruth Marlene Escobar Arevalo de las rosas"
                        disabled="true"
                      />
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <input
                        type="text"
                        className="form-control mb-5"
                        placeholder="13333444-7"
                        disabled="true"
                      />
                    </div>
                    <div className="col-lg-4 col-sm-12"></div>
                    <div className="col-lg-4 col-sm-12">
                      <input
                        type="text"
                        className="form-control mb-5"
                        placeholder="Dirección informatica"
                        disabled="true"
                      />
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <input
                        type="text"
                        className="form-control mb-5"
                        placeholder="Desarrollo"
                        disabled="true"
                      />
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <select
                        className="form-select mb-5"
                        aria-label=""
                        disabled="true"
                      >
                        <option>Cesar Alarcon</option>
                        <option value="xxxx">xxxxx</option>
                        <option value="xxxx">xxxxxxxx</option>
                      </select>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <select
                        className="form-select mb-5"
                        aria-label=""
                        disabled="true"
                      >
                        <option>Cargo</option>
                        <option value="xxxx">xxxxx</option>
                        <option value="xxxx">xxxxxxxx</option>
                      </select>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <select
                        className="form-select mb-5"
                        aria-label=""
                        disabled="true"
                      >
                        <option>Escalafon</option>
                        <option value="xxxx">xxxxx</option>
                        <option value="xxxx">xxxxxxxx</option>
                      </select>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <select
                        className="form-select mb-5"
                        aria-label=""
                        disabled="true"
                      >
                        <option>Grado</option>
                        <option value="xxxx">xxxxx</option>
                        <option value="xxxx">xxxxxxxx</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12 ">
              <div className="card ">
                <div className="card-header ">
                  <h3 className="card-title align-items-start flex-column ">
                    <span className="card-label fw-bolder text-dark ">
                       VER EVALUACIONES DEL FUNCIONARIO
                    </span>
                  </h3>
                </div>
                <div className="card-body ">
                  <div className="col-xl-12 mt-5">
                    <div className="table-responsive">
                      <h4 className="text-gray-900 fw-bolder">
                        Etapas de evaluación
                      </h4>
                      <table className="table table-rounded table-striped border gy-7 gs-7 table-bordered">
                        <thead>
                          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                            <th>Etapa</th>
                            <th>SF11</th>
                            <th>SF12</th>
                            <th>NOTA</th>
                            <th>PTJE F1</th>
                            <th>SF21</th>
                            <th>SF22</th>
                            <th>SF23</th>
                            <th>NOTA</th>
                            <th>PTJE F2</th>
                            <th>SF31</th>
                            <th>SF32</th>
                            <th>NOTA</th>
                            <th>PTJE F3</th>
                            <th>FINAL</th>
                            <th>LISTA</th>
                            <th>DOCUMENTOS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Primera evaluación</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>
                              <a
                                href="#"
                                className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                                data-bs-toggle="modal"
                                data-bs-target="#m-"
                              >
                                nazka  ver
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>Segunda evaluación</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>
                              <a
                                href="#"
                                className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                                data-bs-toggle="modal"
                                data-bs-target="#m-"
                              >
                                nazka  ver
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>Precalificación</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>
                              <a
                                href="#"
                                className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                                data-bs-toggle="modal"
                                data-bs-target="#m-"
                              >
                                nazka  ver
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="table-responsive mt-8">
                      <h4 className="text-gray-900 fw-bolder mt-5 mb-5">
                         Calificación Final
                      </h4>
                      <table className="table table-rounded table-striped border gy-7 gs-7 table-bordered">
                        <thead>
                          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200 ">
                            <th>SF11</th>
                            <th>SF12</th>
                            <th>NOTA</th>
                            <th>PTJE F1</th>
                            <th>SF21</th>
                            <th>SF22</th>
                            <th>SF23</th>
                            <th>NOTA</th>
                            <th>PTJE F2</th>
                            <th>SF31</th>
                            <th>SF32</th>
                            <th>NOTA</th>
                            <th>PTJE F3</th>
                            <th>FINAL</th>
                            <th>LISTA</th>
                            <th>DOCUMENTOS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>8</td>
                            <td>
                              <a
                                href="#"
                                className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                              >
                                 ver
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-xl-12 mt-5">
                    <div className="row">
                      <div className="col-xl-4 mt-5">
                        <div className="notice d-flex  rounded border-info border border-dashed mb-12 p-6">
                          <div className="d-flex flex-stack flex-grow-1">
                            <div className="fw-bold">
                              <h4 className="text-gray-900 fw-bolder mb-5">
                                Respuesta funcionario
                              </h4>
                              <div className="form-check form-check-custom form-check-success form-check-solid mb-5">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  defaultValue=""
                                  name="conforme"
                                  id="conforme-si"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="conforme-si"
                                >
                                  conforme
                                </label>
                              </div>
                              <div className="form-check form-check-custom form-check-danger form-check-solid">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  defaultValue=""
                                  name="conforme"
                                  id="conforme-no"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="conforme-no"
                                >
                                  Disconforme
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 mt-5">
                        <div className="notice d-flex  rounded border-danger border border-dashed mb-12 p-6">
                          <div className="d-flex flex-stack flex-grow-1">
                            <div className="fw-bold">
                              <h4 className="text-gray-900 fw-bolder mb-5">
                                Apelación
                              </h4>
                              <div className="form-check form-check-custom form-check-success form-check-solid mb-5">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  defaultValue=""
                                  name="apelar"
                                  id="apelar"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="apelar"
                                >
                                  Apelare
                                </label>
                              </div>
                              <div className="form-check form-check-custom form-check-danger form-check-solid">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  defaultValue=""
                                  name="apelar"
                                  id="no-apelar"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="no-apelar"
                                >
                                  No apelare
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 mt-5">
                        <div className="notice d-flex  rounded border-danger border border-dashed mb-12 p-6">
                          <div className="d-flex flex-stack flex-grow-1">
                            <div className="fw-bold">
                              <h4 className="text-gray-900 fw-bolder mb-5">
                                Fecha
                              </h4>
                              <strong className="mb-8">
                                Fecha: 22/00/2022
                              </strong>
                              <br />
                              <strong className="mb-8">
                                Firmado con clave unica
                              </strong>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive mt-8">
                        <h4 className="text-gray-900 fw-bolder mt-5 mb-5">
                          Proceso de Apelación
                        </h4>
                        <table className="table table-rounded table-striped border gy-7 gs-7">
                          <thead>
                            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                              <th>SF11</th>
                              <th>SF12</th>
                              <th>NOTA</th>
                              <th>PTJE F1</th>
                              <th>SF21</th>
                              <th>SF22</th>
                              <th>SF23</th>
                              <th>NOTA</th>
                              <th>PTJE F2</th>
                              <th>SF31</th>
                              <th>SF32</th>
                              <th>NOTA</th>
                              <th>PTJE F3</th>
                              <th>FINAL</th>
                              <th>LISTA</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>8</td>
                              <td>LISTA 1</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer d-flex justify-content-end py-6 px-9">
                    <button className="btn btn-light btn-active-light-primary me-2">
                       Ver documentos Apelación
                    </button>
                    <button className="btn btn-primary px-6">
                       Ver calificación Final
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
